import { Component } from '@angular/core';

@Component({
  selector: 'app-terms-of-service-page',
  standalone: true,
  imports: [],
  templateUrl: './terms-of-service-page.component.html',
  styleUrl: './terms-of-service-page.component.css'
})
export class TermsOfServicePageComponent {

}
